function initMap(){
    var map = new google.maps.Map(document.getElementById('map-canvas'), {
        center: new google.maps.LatLng(-28, 135),
        zoom: 4,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    });
    var infoWindow = new google.maps.InfoWindow;
    var panelDiv = document.getElementById('panel');
    var data = new UnicoDataSource();
    var view = new storeLocator.View(map, data, {
        geolocation: false,
        features: data.getFeatures()
    });
    $("#getlocation").on("click", function(e){
        navigator.geolocation.getCurrentPosition(successCallback, errorCallback, options);
    });
    new storeLocator.Panel(panelDiv, {
        view: view
    });
    $("#getlocation").val("");
    function displayLocation(latitude, longitude) {
        var request = new XMLHttpRequest();
        var method = 'GET';
        var url = 'http://maps.googleapis.com/maps/api/geocode/json?latlng=' + latitude + ',' + longitude + '&sensor=true&key=AIzaSyAti4vbxVKmaz2MYCQRxXqphYbiRNXDVqQ';
        var async = true;
        request.open(method, url, async);
        request.onreadystatechange = function() {
            if (request.readyState == 4 && request.status == 200) {
                var data = JSON.parse(request.responseText);
                var address = data.results[0];
                console.log(address.formatted_address);
                $("#getlocation").val(address.formatted_address);
            }
        };
        request.send();
    };
    var successCallback = function(position) {
        var x = position.coords.latitude;
        var y = position.coords.longitude;
        var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
        };
        map.setCenter(pos);
        map.setZoom(10);
        view.updateOnPan_changed();
        view.getFeatures();
        displayLocation(x, y);
    };

    var errorCallback = function(error) {
        var errorMessage = 'Unknown error';
        switch (error.code) {
            case 1:
                errorMessage = 'Permission denied';
                break;
            case 2:
                errorMessage = 'Position unavailable';
                break;
            case 3:
                errorMessage = 'Timeout';
                break;
        }
        console.log(errorMessage);
    };

    var options = {
        enableHighAccuracy: true,
        timeout: 1000,
        maximumAge: 0
    };
};

google.maps.event.addDomListener(window, 'load', function() {
  initMap();
});

$('#xlab-checkbox').change(function(){
    navigateNewUrl();
})
$('#xds-checkbox').change(function(){
    navigateNewUrl();
})

function navigateNewUrl(){
    var xlab = $('#xlab-checkbox').is(':checked') ? 'true' : 'false';
    var xds = $('#xds-checkbox').is(':checked') ? 'true' : 'false';
    window.location.href = `find-a-store?xlab=${xlab}&xds=${xds}`;
}

var _gaq = _gaq || [];
_gaq.push(['_setAccount', 'UA-12846745-20']);
_gaq.push(['_trackPageview']);

(function() {
var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
ga.src = ('https:' === document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
})();
